import { useEffect } from "react";
import { useMap } from "react-leaflet";
import L from "leaflet";

import { DEFAULT_CENTER, DEFAULT_ZOOM } from "../data/carteInteretsUiData";

export function ResizeHandler() {
  const map = useMap();

  useEffect(() => {
    const timer = window.setTimeout(() => {
      map.invalidateSize();
    }, 80);

    return () => window.clearTimeout(timer);
  }, [map]);

  return null;
}

export function MapFocusController({ points = [], selectedPoint }) {
  const map = useMap();

  useEffect(() => {
    if (selectedPoint) {
      map.flyTo([selectedPoint.lat, selectedPoint.lng], Math.max(map.getZoom(), 15), {
        duration: 0.6,
      });
      return;
    }

    if (points.length > 1) {
      const bounds = L.latLngBounds(points.map((point) => [point.lat, point.lng]));
      map.fitBounds(bounds, {
        padding: [35, 35],
        maxZoom: 15,
      });
      return;
    }

    if (points.length === 1) {
      map.flyTo([points[0].lat, points[0].lng], 15, {
        duration: 0.6,
      });
      return;
    }

    map.setView(DEFAULT_CENTER, DEFAULT_ZOOM);
  }, [map, points, selectedPoint]);

  return null;
}